<template>
	<div class="">
		<div class="order_tabs">
			<template v-for="(itme,i) in tabs" >
				<div :key="i" class="tab " :class="{'tab_cho':index==i}" @click="index = i;Postuserlists();pageNo=1;">{{itme.name}}</div>
				<span :key="'F'+i" v-if="tabs.length-1 != i">|</span>
			</template>
		</div>
		<div v-loading="loading">
			<div v-if="orderList.length">
				<div class="order_to">
					<span>商品信息</span>
					<span>发票号</span>
					<span>总金额</span>
					<span>交易状态</span>
					<span>付款期限</span>
					<span>报销状态</span>
				</div>
				<div class="order_zi" v-for="item in orderList" :key="item.id">
					<div class="zi_to">
						<span>{{item.create_time}}</span>
						<span>订单号:{{item.out_trade_no}}</span>
					</div>
					<div class="zi_box">
						<div class="zi_download">
							<img @click="xin.goUrl('/products/'+item.goods[0].goods_id)" :src="item.goods[0].goods_images">
							<div class="zi_name">
								<div class="zi_name_title ">
									<span class="lan" @click="xin.goUrl('/products/'+item.goods[0].goods_id)">{{item.goods[0].goods_name}}</span>
								</div>
								<div class="yijihuanhang">
									<span class="cur_po" @click="xin.goUrl('/oneDetails',{cid:item.goods[0].category_1})">{{item.goods[0].category_name}}</span>
								</div>
							</div>
						</div>
						<div>{{item.invoice_number}}</div>
						<div class="jine">
							<!-- ¥{{item.orders_payable}} -->
							<template v-if="item.alter_payable">
								<div class="huadiao">￥{{item.orders_payable}} </div>
								<div class="xiaos">￥{{item.alter_payable}}</div>
							</template>
							<span v-else class="xiaos">￥{{item.orders_payable}}</span>
						</div>
						<div class="zi_btn">
							<div>{{item.status | oredrS}}</div>
							<div class="lan" @click="xin.goUrl('/orderDetails?oid='+item.id)" >查看订单</div>
							<button v-if="item.status==1||item.status==2" @click="Postoredrcancel(item.id)" class="lan">取消订单</button>
							<div v-if="item.status==4" @click="Postoredrconfirm(item.id)" class="lan">确认收货</div>
						</div>
						<div>{{item.time_out*1000 | timeFormat}}</div>
						<div>{{item.invoice_status | invo}}</div>
					</div>
				</div>
			</div>
			<div v-else class="order_zi">
				<div class="kunasg">
					您的订单空空的~~
				</div>
			</div>
		</div>
		<div class="bottom_paging">
			<el-pagination class="feye" :background="true" :current-page.sync="pageNo" :page-size="limit" layout="prev, pager, next, jumper"
				:total="total" @current-change="pageCurrentChange" :hide-on-single-page="true"></el-pagination>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
// 1: 待付款
// 2: 待发货
// 3: 部分发货
// 4: 待收货
// 5: 已完成
// 6: 已取消
				loading:true,
				total:0,//总数量
				pageNo:1,//当前页
				limit:0,//一页多少条
				activeName:"second",
				index:0,//'所有订单','待付款','待发货','待收货','已完成','已取消'
				tabs:[{
					name:'所有订单',
				},{
					index:1,
					name:'待付款'
				},{
					index:2,
					name:'待发货'
				},{
					index:3,
					name:'部分发货'
				},{
					index:4,
					name:'待收货'
				},{
					index:5,
					name:'已完成'
				},{
					index:6,
					name:'已取消'
				}],
				orderList:[],//
			}
		},
		created(){
			this.Postuserlists();
		},
		methods:{
			async Postoredrconfirm(orders_id){
				this.$confirm('您确定要确认收货吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
				}).then(async () => {
					let {data,code} = await this.api.Postoredrconfirm({orders_id});
					if(code==200){
						this.$message.success('订单收货成功!');
						this.Postuserlists();
					}
				});
			},
			async Postoredrcancel(orders_id){//取消订单
				this.$confirm('您确定要取消订单吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
				}).then(async () => {
					let {code} = await this.api.Postoredrcancel({orders_id});
					if(code==200){
						this.$message.success('订单取消成功!');
						this.Postuserlists();
					}
				});
			},
			pageCurrentChange(val) {//分页查询
				this.pageNo = val;
				this.Postuserlists();
			},
			async Postuserlists(){//获取订单
				this.loading = true;
				let {code,data} = await this.api.Postuserlists({status:this.tabs[this.index].index,page:this.pageNo});
				this.orderList = data.data||[];
				this.total = data.total;
				this.limit = data.per_page;
				this.loading = false;
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.huadiao{
		text-decoration: line-through;
		font-size: 14px;
	}
	.order_zi{
		margin-top: 20px;
		.zi_box{
			height: 160px;
			border: 1px solid #f2f2f2;
			display: flex;
			
			align-items: center;
			color: #333333;
			.zi_download{
				display: flex;
				
			}
			div:nth-child(1) {
				flex: 3;
				text-align: center;
			}
			div:not(:nth-child(1)) {
				flex: 1;
				text-align: center;
			}
			.zi_name{
				margin-left: 10px;
				height: 100px;
				
				// display: flex;
				// flex-direction: column;
				// justify-content: space-between;
				width: 110px;
				.yijihuanhang{
					margin-top: 20px;
					text-align: left;
				}
				.lan{
					margin-top: 20px;
				}
				.zi_name_title{
					text-align: left;
					overflow:hidden;
					text-overflow:ellipsis;
					display:-webkit-box;
					-webkit-box-orient:vertical;
					-webkit-line-clamp:2;
				}
			}
			.jine{
				// font-size: 24px;
			}
			.zi_btn{
				div{
					flex: 0;
				}
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: space-around;
				height: 100px;
			}
			img{
				width: 100px;
				height: 100px;
				margin-left: 40px;
				cursor: pointer;
			}
		}
		.zi_to{
			line-height: 40px;
			// padding-left: 40px;
			height: 40px;
			color: #666;
			// border: 1px dashed #666;
			background: #F2F2F2;
			span{
				margin-left: 40px;
			}
		}
	}
	.order_to{
		margin-top: 30px;
		color: #fff;
		height: 40px;
		background: #005599;
		display: flex;
		align-items: center;
		span:nth-child(1){
			flex: 3;
			text-align: center;
		}
		span:not(:nth-child(1)){
			flex: 1;
			text-align: center;
		}
	}

</style>
